import { ValueEventArgs } from "../../shared/models/value-event-args";
import { IMixingContainer } from "../interfaces/i-mixing-container";

export class ContainerChangedEventArgs extends ValueEventArgs<IMixingContainer>
{
}
